<div class="container">
  <mat-progress-spinner mode="indeterminate" [diameter]="80"></mat-progress-spinner>
</div>
